module.exports = __webpack_public_path__ + "assets/img/7.c37a33db.jpg";